import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { AutobizTheme, defaultTheme } from 'autobiz-strap';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { store, persistor } from './Store/store';
import { languages } from './language-context';
import { Auth } from './config/configuration/react';

const country = Auth.preferredLanguage();

function onUpdateHandler() {
  window.location.reload(true);
}

if (languages[country] != null) {
  document.title = languages[country].title;
} else {
  document.title = 'Carcheck';
}

ReactDOM.render(
  // eslint-disable-next-line react/jsx-filename-extension
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <AutobizTheme theme={defaultTheme}>
        <App />
      </AutobizTheme>
    </PersistGate>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register({
  onUpdate: onUpdateHandler,
});
